module.exports = __webpack_public_path__ + "img/avatar6.602bb8dc.png";